import LayoutActividad from "../../../components/LayoutActividad";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEdit } from "@fortawesome/free-solid-svg-icons";
import { modulo13 } from "../../../routes/Module13";
import Sidebar from "../Sidebar";
import Imagen1 from "../../../images/modulo13/jailerfrio.png";
import GuiaDocente from "../../../components/GuiaDocente";
import AudioPlayer from "../../../audioPlayer/AudioPlayer";
import Audio from "../../../audios/modulo13/Unidad1Actividad4.mp3";

const Actividad6 = () => {
  const infoUnidad = modulo13.content[0];
  const infoAct = modulo13.content[0].activities[4];
  const crumbs = [
    {
      title: modulo13.title,
      url: "/" + modulo13.url,
    },
    {
      title:
        modulo13.content.length === 1
          ? `${infoAct.name}`
          : `${infoUnidad.name} > ${infoAct.name}`,
      url: infoAct.path,
    },
  ];

  const pages = {
    titleNext: `${modulo13.content[0].name}: ${modulo13.content[0].activities[5].name}`,
    linkNext: `${modulo13.url}/${modulo13.content[0].path}/${modulo13.content[0].activities[5].path}`,
    titlePrev: `${modulo13.content[0].name}: ${modulo13.content[0].activities[3].name}`,
    linkPrev: `${modulo13.url}/${modulo13.content[0].path}/${modulo13.content[0].activities[3].path}`,
  };
  const metadata = {
    color: modulo13.color,
    title: `${modulo13.title} - ${infoAct.name}`,
    name: modulo13.title,
  };

  return (
    <LayoutActividad
      pages={pages}
      crumbs={crumbs}
      sidebar={<Sidebar />}
      modulo={metadata}
    >
      <p>
        <small className={`c-${modulo13.color} hat-text`}>
          <FontAwesomeIcon icon={faEdit} /> Trabajamos con las palabras
        </small>
      </p>

      <h2 className="mb-5">{infoAct.name}</h2>
          <AudioPlayer track={Audio} />
      <div className="row">
        <div className="col-lg-10 col-12 p-0">
          <ul className="">
            <li>
              Lee lo que nos cuenta Jailer acerca de cómo se está adaptando a
              vivir en Arequipa.
            </li>
          </ul>
        </div>
      </div>

      <div className="row align-items-center mt-4">
        <div className="col-md-4 col-12">
          <img src={Imagen1} alt="Anuncio" className="img-fluid" />
        </div>
        <div className="col-md-8 col-12">
          <p className="fs-5 p-3 p-md-0">
            Hace un mes que llegamos a Arequipa con mi papá que va a trabajar en
            la mina. Tuve que comprarme una casaca en el mercado. Mucho frío
            hace acá. Bien raro el mercado: no había aguaje ni cecina. Pero
            probé una sopa bien rica, chupe de habas, que me calentó el cuerpo.
          </p>
        </div>
        <div className="col-md-10 mt-5">
          <ul>
            <li>Ahora responde: ¿qué ha hecho Jailer para adaptarse?</li>
          </ul>
          <textarea className="form-control" rows={3} />
        </div>
      </div>

      <GuiaDocente>
        <ul>
          <li>
            Lea la primera indicación: Lee lo que nos cuenta Jailer acerca de
            cómo se está adaptando a vivir en Arequipa. Pida a un(a) estudiante
            que lea en voz alta el siguiente párrafo: Hace un mes que llegamos a
            Arequipa con mi papá que va a trabajar en la mina. Tuve que
            comprarme una casaca en el mercado. Mucho frío hace acá. Bien raro
            el mercado: no había aguaje ni cecina. Pero probé una sopa bien
            rica, chupe de habas, que me calentó el cuerpo. Comente que Jailer es un niño que viene de la selva y que ahora
            tiene que adaptarse a una nueva ciudad. Pregunte qué significa
            “adaptarse” (acomodarse a un lugar o situación distintos de los que
            acostumbrados). Lea la siguiente indicación: Ahora responde: ¿qué ha
            hecho Jailer para adaptarse? Pida oralmente sus
            respuestas. Acuerden cuál será la respuesta aproximada que
            escribirán en el espacio correspondiente (Posible respuesta: Para
            adaptarse, Jailer se compró una casaca y probó una comida que no
            conocía).
          </li>
        </ul>
      </GuiaDocente>
    </LayoutActividad>
  );
};

export default Actividad6;
